import { registerPlugin } from '@capacitor/core';

const MFAPhoneAuth = registerPlugin('MFAPhoneAuth');

export default MFAPhoneAuth;
